import { createZodDto } from 'nestjs-zod/dto';
import { CreatedServiceAccountIdentityResponseSchema } from '../service-identity';
import { ServiceAccountResponseSchema } from './service-account-response.dto';
export const CreatedServiceAccountResponseSchema = ServiceAccountResponseSchema.extend({
    serviceIdentity: CreatedServiceAccountIdentityResponseSchema.optional(),
});
export class CreatedServiceAccountResponseDto extends createZodDto(CreatedServiceAccountResponseSchema) {
}
